// Where each rotating member quote sits on the MembersSection stage.
//
// Split out of MembersSection.tsx so the lookup can be tested on its own.

export interface Zone {

  // Vertical anchor: provide either topPct OR bottomPct (percent of stage height).
  topPct?: number;
  bottomPct?: number;
  // Desired horizontal anchor (percent from stage left).
  // Clamped at render time so the quote always fits within the stage width.
  leftPct: number;
}

// Quotes scatter across the stage on varied (left%, top%) coordinates, but every
// quote is left-anchored so the text reads left-to-right from its position. Long
// quotes get clamped leftward at render time if their natural width would overflow.
export const ZONES_DESKTOP: Zone[] = [
  { topPct: 0,     leftPct: 4 },
  { topPct: 45,    leftPct: 25 },
  { topPct: 25,    leftPct: 4 },
  { bottomPct: 0,  leftPct: 20 },
  { topPct: 10,    leftPct: 30 },
  { bottomPct: 8,  leftPct: 6 },
  { topPct: 40,    leftPct: 14 },
  { bottomPct: 15, leftPct: 28 },
];
// Sequence picked so each next zone is far from the previous in (left, top) space.
export const ZONE_SEQUENCE_DESKTOP = [0, 6, 2, 4, 1, 7, 3, 5];

export const ZONES_MOBILE: Zone[] = [
  { topPct: 0,    leftPct: 5 },
  { bottomPct: 0, leftPct: 5 },
];
export const ZONE_SEQUENCE_MOBILE = [0, 1];

/**
 * The zone for the quote at `seqIndex` in the current layout.
 *
 * `seqIndex` survives a layout switch: it counts through the 8 desktop zones,
 * and when the viewport crosses into mobile (a phone rotating, a window
 * narrowing) there are only 2. Indexing the mobile sequence with 2..7 returned
 * undefined and the render crashed reading `zone.leftPct` (Datadog 649619ec,
 * "undefined is not an object (evaluating 'A.leftPct')"). Wrapping here keeps
 * every index in range whichever layout is current.
 */
export function pickZone(isMobile: boolean, seqIndex: number): Zone {
  const zones = isMobile ? ZONES_MOBILE : ZONES_DESKTOP;
  const sequence = isMobile ? ZONE_SEQUENCE_MOBILE : ZONE_SEQUENCE_DESKTOP;
  const step = ((seqIndex % sequence.length) + sequence.length) % sequence.length;
  return zones[sequence[step]];
}
